import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "uppercase text-raleway-13" }, "password", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "uppercase text-raleway-13" }, "password", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "uppercase text-raleway-13" }, "old password", -1)
const _hoisted_4 = {
  class: "btn btn-default mt-5",
  type: "submit"
}

import { validationUpdatePassword } from '@/utils/validation/updatePassword'
import { ChangePasswordType, ChangePasswordErrorType } from './type'
import { getUserId } from '@/utils/token/getUserId'
import { change } from '@/hook/change/change'
import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'UpdatePasswordView',
  setup(__props) {

const userId = getUserId()
const dataInput = ref<ChangePasswordType>({password1: '', password2: '', old_password: ''})
const errorPassword = ref<ChangePasswordErrorType>({password1: false, password2: false, old_password: false, coincidence: false})

const ch = (event: Event) => change(event, dataInput)

const changePassword = async (event: Event) => {
    event.preventDefault()
    validationUpdatePassword(dataInput, errorPassword, userId)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    class: "form mt-5 pt-5",
    onSubmit: changePassword
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["input-wrapper mb-2", { 'error-input':  errorPassword.value.password1 }])
    }, [
      _hoisted_1,
      _createElementVNode("input", {
        onInput: ch,
        type: "text",
        name: "password1",
        class: "input"
      }, null, 32)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["input-wrapper mb-2", { 'error-input':  errorPassword.value.password2 }])
    }, [
      _hoisted_2,
      _createElementVNode("input", {
        onInput: ch,
        type: "text",
        name: "password2",
        class: "input"
      }, null, 32)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["input-wrapper mb-2", { 'error-input': errorPassword.value.old_password }])
    }, [
      _hoisted_3,
      _createElementVNode("input", {
        onInput: ch,
        type: "password",
        name: "old_password",
        class: "input"
      }, null, 32)
    ], 2),
    _createElementVNode("button", _hoisted_4, _toDisplayString(_ctx.$tc('Change password')), 1)
  ], 32))
}
}

})